import React from 'react'
import { Link } from 'react-router-dom'
import { useNavigationContext } from '#src/components/Header/StandardHeader/NavigationContext'
import { DepartmentNavigationTopLevelItemFragment } from '#src/components/Header/NavHierarchyFragments.generated'
import { serializeSearchQuery, getQueryParamsFromDeptNavLink } from '#src/services/search'
import ArrowRight from '#src/components/Header/StandardHeader/icons/arrow-right.svg'
import keyBy from 'lodash/keyBy'
import styles from './styles.css'

interface TopLevelItemProps {
  topLevelItem: DepartmentNavigationTopLevelItemFragment
}

const TopLevelItem: React.FC<TopLevelItemProps> = ({ topLevelItem }) => {
  const navContext = useNavigationContext()

  if (topLevelItem.labelLink) {
    const queryParams = getQueryParamsFromDeptNavLink(topLevelItem.labelLink)
    const linkLocation =
      queryParams &&
      serializeSearchQuery({
        categorySlug: queryParams.categorySlug,
        selections: queryParams.facets ? keyBy(queryParams.facets, 'name') : undefined,
        filters: queryParams.filters,
        entryPoint: 'nav-browse'
      })
    const linkTarget = {
      pathname: linkLocation?.pathname,
      search: linkLocation?.searchParams.toString()
    }

    return (
      <Link
        to={{
          pathname: linkTarget?.pathname,
          search: linkTarget?.search
        }}
        onClick={() => navContext?.onNavItemSelected()}
        className={styles.item}
      >
        <div className={styles.itemHighlight}>
          <div className={styles.itemHighlightLabel}>
            <span>{topLevelItem.label}</span>
            <ArrowRight className={styles.arrow} />
          </div>
        </div>
      </Link>
    )
  } else {
    return <div className={styles.itemWithoutHighlight}>{topLevelItem.label}</div>
  }
}

export default TopLevelItem
